
<hr class="line" [ngStyle]="{ background: newColor }" />

<app-topnav [pagename]="'SCRAII Admin Portal'"></app-topnav>

<div class="px-4 py-2">
    <div class="card class-card">
        <div class="d-flex align-items-center justify-content-between p-3">
            <div class="text-left">
                <h2 class="du-user-management-header">User Management</h2>
            </div>
            <div class="text-right">
                <button type="button" class="scraii-primary-btn"
                    (click)="openModel()">
                    Create a User
                </button>
            </div>
        </div>

        <div *ngIf="!loader">
            <loading ></loading>
        </div>

        <div style="height: 200px; width: auto; " *ngIf="loader && rowData.length==0">
            <span class="bg-text"> {{ error_name ? error_name : 'There is no users' }} </span>
        </div>

        <div class="du-user-management-grid-container px-3 pb-3">
            <ag-grid-angular
                [style.display]="(rowData?.length==0 || error_name) ? 'none' : 'block'"
                class="ag-theme-alpine user-management-grid"
                [class]="themeClass"
                [rowData]="rowData"
                [columnDefs]="colDefs"
                [defaultColDef]="defaultColDef"
                [rowHeight]="40"
                [pagination]="true"
                [paginationPageSize]="15"
                [suppressDragLeaveHidesColumns]="true"
                >
            </ag-grid-angular>
        </div>
    </div>
</div>